'use client';

import { create } from 'zustand';
import type { Id } from 'convex/_generated/dataModel';

interface DashboardStore {
  selectedGardenId: Id<'gardens'> | null;

  setSelectedGardenId: (id: Id<'gardens'> | null) => void;
}

export const useDashboardStore = create<DashboardStore>((set) => ({
  selectedGardenId: null,

  setSelectedGardenId: (id) => set({ selectedGardenId: id }),
}));
